import TrainingPackaged from "./TrainingPackaged";

export default TrainingPackaged;
